// extracted by mini-css-extract-plugin
module.exports = {"container":"SetupNotifications_container__x4NWV","row":"SetupNotifications_row__2HPjw"};